import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {

    getInventoriesForActiveBookings: function (centreId, companyId) {
        return axios.get(
            API.url(Endpoints.Companies.BookingInventories, {company_id: companyId, centre_id: centreId})
        ).then((res) => {
            return res.data.inventories;
        });
    },


    list: function (centreId) {
        return axios.get(
            API.url(Endpoints.Companies.List, {centre_id: centreId})
        ).then((res) => {
            return res.data.companies;
        });
    }


}
